//(function () {
//    'use strict';

//    angular.module("imApp").factory("productionStatusService", ['$ihttp', function ($ihttp) {
//        let service = {
//            scanItem: function (setting) {
//                return $ihttp.post({
//                    method: 394,
//                    parameters: setting
//                });
//            }
//        };

//        return service;
//    }]);
//})();
